/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Track_View_Allocation1Inputs */

const en_coinvestments_track_view_allocation1 = /** @type {(inputs: Coinvestments_Track_View_Allocation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocation`)
};

/**
* | output |
* | --- |
* | "Allocation" |
*
* @param {Coinvestments_Track_View_Allocation1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_track_view_allocation1 = /** @type {((inputs?: Coinvestments_Track_View_Allocation1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Track_View_Allocation1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_track_view_allocation1(inputs)
});
export { coinvestments_track_view_allocation1 as "coInvestments_track_view_allocation" }